/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevRobotIcon16Light = forwardRef('DevRobotIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.5 7.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M5.5 8.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1.866a1 1 0 1 0-1 0V3H5a3 3 0 0 0-3 3v1H.5a.5.5 0 0 0 0 1H2v3a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3V8h1.5a.5.5 0 0 0 0-1H13V6a3 3 0 0 0-3-3H8V1.866ZM5 4h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" })));
});
